// @ts-nocheck
import styled from 'styled-components';

export const ScheduledReportsTabStyle = styled.div`
  .inputSearch {
    flex: 1 1 auto;
  }
  .fontBold {
    font-family: ${props => props.theme.fontBold};
  }
`;
